// Burmese translations
export const my: Record<string, string> = {
  'menu.dashboard': 'ဒက်ရှ်ဘုတ်',
  'menu.customers': 'ဖောက်သည်များ',
  'menu.products': 'ထုတ်ကုန်များ',
  'menu.users': 'အသုံးပြုသူများ',
  'menu.settings': 'ဆက်တင်များ',
  'menu.logout': 'ထွက်ရန်',
  'dashboard.title': 'ဒက်ရှ်ဘုတ်',
  'dashboard.newOrder': 'မှာယူမှုအသစ်',
  'order.title': 'မှာယူမှုအသစ်',
  'order.customer': 'ဖောက်သည်',
  'order.products': 'ထုတ်ကုန်များ',
  'order.total': 'စုစုပေါင်း',
  'users.title': 'အသုံးပြုသူများ',
  'users.name': 'အမည်',
  'users.email': 'အီးမေးလ်',
  'common.yes': 'ဟုတ်ကဲ့',
  'common.no': 'မဟုတ်ဘူး',
  'common.cancel': 'ပယ်ဖျက်ရန်',
  'common.save': 'သိမ်းဆည်းရန်',
  'common.search': 'ရှာဖွေရန်',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'လော့ဂ်အင်',
  'login.welcome': 'ကြိုဆိုပါသည်, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'အီးမေးလ်',
  'signup.phone': 'ဖုန်း',
  'menu.reportsAndAccounting': 'အစီရင်ခံစာနှင့် စာရင်းကိုင်',
  'menu.systemAndCommunication': 'စနစ်နှင့် ဆက်သွယ်ရေး',
};